import uiEn from './i18n/en/ui.js';
import permissionsEn from './i18n/en/permissions.js';
import UploadButton from './components/UploadButton.vue'
import UploadedFile from './components/UploadedFile.vue'
import UploadsCard from './components/uploads/UploadsCard.vue'

import routes from './routes/routes.js'
import leftMenuConfig from './menus/left.js'; // Import the config object
import topMenuConfig from './menus/top.js';

export default ({ app, addLeftMenuItem, addTopMenuItem, addTranslations, addPermissionTranslations, router }) => {
  // ADD LANGUAGES
  addTranslations('en', uiEn,'uploadable');
  addPermissionTranslations('en', permissionsEn);

  app.component('UploadButton', UploadButton)
  app.component('UploadedFile', UploadedFile)
  app.component('UploadsCard', UploadsCard)

  // ADD ROUTES
  routes.forEach(route => {
    router.addRoute(route);
  });

  // ADD MENU LEFT ITEMS
  if (leftMenuConfig.items) {
    leftMenuConfig.items.forEach(item => {
      // addLeftMenuItem(item);
    });
  }
  // ADD MENU TOP ITEMS
  if (topMenuConfig.items) {
    topMenuConfig.items.forEach(item => {
      // addTopMenuItem(item);
    });
  }
}
